window.TUCContainer = Container.extend({
    initialize: function() {
        if (this.attributes.forceFullsize === true) WindowHelper.setFullscreen();

        this.urlHelper = new URLHelper(window.location);

        var startPageFromQueryString = this.urlHelper.getQueryVariableByName("startPage");

        if (startPageFromQueryString) this.attributes.startPage = startPageFromQueryString;

        this.name = this.attributes.name ? $(this.attributes.name) : "no-name-" + String(new Date().toDateString()).split(" ").join("-");

        // Assign a different DOM just in case you don't want the container to be the whole page.
        this.dom = this.attributes.dom ? $(this.attributes.dom) : $(window.document);

        // Scroller element selector
        this.scroller = this.attributes.scroller ? this.attributes.scroller : Container.DEFAULT_SCROLLER;

        // Define a traking interface if supplied
        this.tracking = this.attributes.tracking ? this.attributes.tracking : undefined;
        this.interactions = this.attributes.interactions ? this.attributes.interactions : {};

        // Set a start page if supplied
        this.startPage = this.attributes.startPage ? this.attributes.startPage : TUCContainer.START_PAGE;

        // Set the enviroment to locked
        this.isLocked = this.attributes.locked ? this.attributes.locked : false;

        // Set the enviroment to locked
        this.showScreenIds = this.attributes.showScreenIds ? this.attributes.showScreenIds : false;

        // Set the browser to cache/uncache the files being loaded
        this.isCached = this.attributes.cached ? this.attributes.cached : false;

        // Set default language for the course
        this.language = this.attributes.language ? this.attributes.language : "";

        this.courseXML = this.attributes.courseXML ? this.attributes.courseXML : "";

        this.isShowIntro = this.attributes.isShowIntro;

        this.isShowScore = this.attributes.isShowScore === true;

        if (!this.isLocked) {
            $(this.dom).addClass("unlocked");
        }

        if (this.tracking) {
            // Create an interface to manage completion of course/units/pages/blocks
            this.lmsAdaptor = new LMSAdaptor(this);
        }

        this.preloader = new AssetLoader({
            name: "pre"
        });

        // Intialise the browser detection class for reference later on
        BrowserDetect.init();

        LanguageManager.initialize(this.attributes.languagePath, this.language);

        // ManifestHelper.initialize();

        if (!this.isLocked && this.logging) this.countCSSRules();

        //After preload complete
        this.setup();
    },

    handleCourseLoaded: function() {		
		// Add a dependency for Firebase check
		var fire = container.componentList.FirebaseStorage;		
		
		// Fallback check to see handle if the firebase session is never started.
		this.timer = new Timer({ timerInterval: 1, duration: 30 });
		// this.timer.bind("onTimerTick", function (e) {
		// 	Logger.info("TucContainer.User.waiting... ", e.count, e.duration, fire.user);
		// }, this);
		this.timer.bind("onTimerCompleted", function (e) {
			this.stopListening(fire, "onFirebaseAuthStateChanged");
			this.stopListening(fire, "afterUserDataLoad");
			this.begin( fire.config.redirect.sessionNew );
		}, this);
		
		this.timer.start();

		// Normal expected code for firebase auth.
		this.listenToOnce(fire, "onFirebaseAuthStateChanged", (e) => {

			// console.info("Navigation.onFirebaseAuthStateChanged", e)
			if (!e.user) {
				if( !this.timer.isFinsihed ) this.timer.stop();
                this.begin( fire.config.redirect.sessionNew );

			} else {
				if( !this.timer.isFinsihed ) this.timer.stop();
				this.listenToOnce(fire, "afterUserDataLoad", (e) => {
					this.begin( fire.config.redirect.sessionDetected );
				}, this);
			}

		});

		fire.doFirebaseStart();
	},
	
	begin: function( targetPage ) {
		// console.info("Navigation.begin", targetPage)
		this.removePreloader();
		this.lmsAdaptor.setup();
		this.trigger("onLoadComplete", {
			target: this
		});
			
		if( targetPage !== undefined ) {
			this.router.changePage( targetPage );
			return;
		}

	}
}, {
    START_PAGE: "010_010"
});
